import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page-cover_word flex-column flex-wrap cursor-pointer"
}
const _hoisted_2 = { class: "mb-5" }
const _hoisted_3 = {
  key: 0,
  class: "mb-5",
  style: {"margin-top":"0"}
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 1,
  class: "page-cover_word flex-column flex-wrap cursor-pointer"
}

import { IonButton, popoverController } from "@ionic/vue"
import http from "@/js/http"
import store from "@/js/store"
import { onBeforeUnmount, onMounted, ref } from "vue"
import { openMsgToast } from "@/views/AIGenerate/openModal"
import { useStorage } from "@vueuse/core/index"
import getOssPlayInstance from "@/js/ossPlay"


export default /*@__PURE__*/_defineComponent({
  __name: 'ArticlePopover',
  props: ["sentence", "type", "gptStr", "descContent", "fromPrepareOrigin"],
  setup(__props) {

/* disabled-eslint */
const props = __props
const audioPlayer = ref()
const mediaType = ref()
const aiTheme = useStorage("ai-theme", "brown", localStorage)
const bofangIcon = ref("icon-bofang3")
const timer = ref(0)

// 打开AI词典
async function routerToAiVocabulary(word: string) {
  audioStop()
  await popoverController.dismiss({ status: "关闭AI词典", word: word })
}

async function putIntoGlossary() {
  const appointment = store.getAppointment()
  const params = {
    aptmId: appointment.aptmId,
    courseId: appointment.courseId,
    word: props.sentence.trim(),
    courseType: appointment.courseType,
  }

  if (props.fromPrepareOrigin) {
    popoverController.dismiss({ status: "关闭popover" }).catch((e) => console.log(e))
    await openMsgToast("添加成功。")
    return
  }

  http.post("/readingVocabulary/addReadingWordToPersonal", params).then(async (res) => {
    if (res.data.success) {
      popoverController.dismiss({ status: "关闭popover" }).catch((e) => console.log(e))
      await openMsgToast(res.data.messageExtra)
    } else {
      await openMsgToast("加入生词本失败")
    }
  })
}

function audioStop() {
  // if (mediaType.value === "MEDIA_SOURCE") {
  //   if (audioPlayer.value?.pause) {
  //     audioPlayer.value.pause();
  //   }
  // } else if (mediaType.value === "AUDIO_CONTEXT") {
  //   if (audioPlayer.value) {
  //     audioPlayer.value.close();
  //   }
  // }
  // bofangIcon.value = "icon-bofang3";
  // clearInterval(timer.value);
  if (audioPlayer.value) {
    audioPlayer.value.pause()
  }
}

function audioPlay() {
  audioPlayer.value = getOssPlayInstance().init({ msg: props.sentence })
  audioPlayer.value.play()
  // audioPlayStream(props.sentence, (callbackData: any, type: string) => {
  //   mediaType.value = type;
  //   let num = 0;
  //   if (mediaType.value === "MEDIA_SOURCE") {
  //     audioPlayer.value = new Audio(callbackData);
  //     audioPlayer.value.oncanplay = function () {
  //       audioPlayer.value.play();
  //     };
  //     audioPlayer.value.onended = function () {
  //       console.log("ended");
  //       bofangIcon.value = "icon-bofang3";
  //       clearInterval(timer.value);
  //     };
  //     audioPlayer.value.oncanplaythrough = () => {
  //       console.log("loading");
  //       clearInterval(timer.value);
  //       timer.value = window.setInterval(() => {
  //         num = ++num % 3;
  //         bofangIcon.value = `icon-bofang${num + 1}`;
  //       }, 300);
  //     };
  //   } else if (mediaType.value === "AUDIO_CONTEXT") {
  //     audioPlayer.value = callbackData;
  //   }
  // });
}

onBeforeUnmount(() => {
  audioStop()
})
onMounted(() => {
  // 初始化 Audio 播放器
  /* eslint-disable */
  // audioPlayer.value = new AudioPlayer("/assets/js");
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["page-cover flex-row justify-center", _unref(aiTheme)])
  }, [
    (props.type === 'word')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h3", null, [
            _createElementVNode("span", null, _toDisplayString(props.sentence), 1),
            _createElementVNode("span", null, [
              _createElementVNode("i", {
                id: "ai-sentence-audio",
                class: _normalizeClass(["iconfont", bofangIcon.value]),
                style: {"color":"var(--text-import-color)","margin-left":"2vw","vertical-align":"middle"},
                onClick: audioPlay
              }, null, 2)
            ])
          ]),
          _createElementVNode("p", _hoisted_2, _toDisplayString(props.gptStr), 1),
          (props.descContent)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                _cache[0] || (_cache[0] = _createElementVNode("span", null, "关键词描述：", -1)),
                _createElementVNode("span", {
                  innerHTML: props.descContent
                }, null, 8, _hoisted_4)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_unref(IonButton), {
            class: "page-cover_word-button",
            shape: "round",
            onClick: putIntoGlossary
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("加入生词本 ", -1)
            ]))]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (['sentence'].includes(props.type))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("p", null, _toDisplayString(props.gptStr), 1)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})